import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Panel } from 'rsuite';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../containers/inventory/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import ResultHeader from './ResultHeader';
import GuestSummaryList from '../../../../components/inventory/reports/GuestSummaryList';
import GuestSummarySearchForm from '../../../../components/inventory/reports/GuestSummarySearchForm';
import {
  getIsFetched,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/guest-summary';

export default () => {
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  return (
    <PageLayout>
      <PageHeader title="Guest Summary Report">
        <GuestSummarySearchForm />
      </PageHeader>
      <Content>
        {isFetching && <ContentLoader />}
        {isFetched && (
          <Panel bodyFill bordered header={<ResultHeader />}>
            <GuestSummaryList />
          </Panel>
        )}
      </Content>
    </PageLayout>
  );
};
